import get from "lodash/get";
import { GetScore, Lifter, Meet } from "types";
import { toKg } from "util/conversions";
import { getTotal } from "util/lifterHelper";
import { isLbsMeet } from "util/meetHelper";
import { ageCoef } from "./age";

export const dotsCoef = function (lifter: Lifter, meet: Meet) {
  const parameters = {
    MALE: {
      a: -0.000001093,
      b: 0.0007391293,
      c: -0.1918759221,
      d: 24.0900756,
      e: -307.75076,
    },
    FEMALE: {
      a: -0.0000010706,
      b: 0.0005158568,
      c: -0.1126655495,
      d: 13.6175032,
      e: -57.96288,
    },
  };

  let bw = lifter.bodyWeight;

  if (!bw) {
    return 0;
  }

  if (!lifter.gender) {
    return 0;
  }

  if (isLbsMeet(meet)) {
    bw = toKg(bw);
  }

  const p = get(parameters, lifter.gender);
  if (!p) {
    return 0;
  }

  return (
    500.0 /
    (p.a * Math.pow(bw, 4) +
      p.b * Math.pow(bw, 3) +
      p.c * Math.pow(bw, 2) +
      p.d * bw +
      p.e)
  );
};

export const dotsFormula = function (
  total: number,
  lifter: Lifter,
  meet: Meet
) {
  if (total <= 0) {
    return 0;
  }

  return total * dotsCoef(lifter, meet);
};

export const getDotsPoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });
  if (isLbsMeet(meet)) {
    total = toKg(total);
  }

  return dotsFormula(total, lifter, meet);
};

export const getDotsAndAgePoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  return (
    getDotsPoints({ lifter, division, meet, forecasted }) *
    ageCoef(lifter, meet)
  );
};
